import { ActionTree } from "vuex";
import { RootState } from "../types";
import { JobState } from "./types";

export const actions: ActionTree<JobState, RootState> = {};
